import React, {useState} from 'react'
import {Navigate, Route, Routes, Outlet, useParams} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {Overview} from '../../../modules/profile/components/Overview'
import {Settings} from '../../../modules/accounts/components/settings/Settings'
import {AccountHeader} from '../../../modules/accounts/AccountHeader'
import SubAdminDetailsHeader from './SubAdminDetailsHeader'
import SubAdminDetailsPage from './SubAdminDetailsPage'
import SubAdminSettings from './SubAdminSettings'
// import {gql, useQuery} from '@apollo/client'

const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Sub Admin',
    path: 'apps/user-management/users/details-page/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

// const GET_SUBADMIN_QUERY: any = gql`
//   query Query($id: ID) {
//     getSubAdminById(id: $id) {
//       _id
//       name
//       email
//       phone
//       country
//       status
//       subAdminType
//       role {
//         isAdmin
//         isSubAdmin
//       }
//       createdAt
//     }
//   }
// `

const SubAdminRoutes: React.FC = () => {
  const {id} = useParams()

  console.log(id, 'id')
  // const {loading, error, data}: any = useQuery(GET_SUBADMIN_QUERY, {variables: {id}})

  const [loading, setLoading] = useState<boolean>(false)
  const [data, setData] = useState<any>()

  console.log(data, 'data')
  return (
    <Routes>
      <Route
        element={
          <>
            <SubAdminDetailsHeader data={data?.getSubAdminById} />
            <Outlet />
          </>
        }
      >
        <Route
          path='overview'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
              <SubAdminDetailsPage data={data?.getSubAdminById} />
            </>
          }
        />
        <Route
          path='setting'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
              <SubAdminSettings data={data?.getSubAdminById} />
            </>
          }
        />
        <Route
          index
          element={<Navigate to='/apps/user-management/users/details-page/overview' />}
        />
      </Route>
    </Routes>
  )
}

export default SubAdminRoutes
